import { AppBar } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

import CommoditiesMenu from '../Components/CommoditiesMenu';
import PageRoutes from '../Config/PageRoutes';
import classes from '../Style/DesktopHeader.scss';

const DesktopHeader = (props) => {
	return (
		<React.Fragment>
			{(props.path.indexOf(PageRoutes.CHAPTER_ONE) > -1 ||
				props.path.includes(PageRoutes.COMMODITY_ROOT)) && (
				<Box>
					<CommoditiesMenu />
				</Box>
			)}
		</React.Fragment>
	);
};

export default DesktopHeader;
